import {useEffect, useRef, useState} from 'react';

interface Options {
  threshold?: number;
  once?: boolean;
  rootMargin?: string;
}

export const useElementOnScreen = <T extends HTMLElement>(
  options: Options = { threshold: 0.1, once: true }
) => {
  const containerRef = useRef<T>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        if (options.once) observer.disconnect();
      }
    }, options);

    const target = containerRef.current;
    if (target) observer.observe(target);

    return () => {
      if (target) observer.unobserve(target);
    };
  }, [options.threshold, options.once, options.rootMargin]);

  return [containerRef, isVisible] as const;
};
